import { Form, Formik } from 'formik';
import { Box, Button, Grid } from '@mui/material';
import { Modal } from '@shared/components/modals/Modal';
import { FormPart } from '@modules/shared/components/FormPart';
import { TextInputField } from '@shared/fields/TextInputField';
import { SelectDateField } from '@shared/fields/SelectDateField';
import { IFormFieldConfig } from '@shared/components/FormFieldsConstructor';
import { CreditCardInputField } from '@shared/fields/CreditCardInputField';
import { CvvInputField } from '@shared/fields/CvvInputField';
import { SaveButton } from '@shared/components/SaveButton';
import { CommonButtonWrapper } from '@styles/CommonStyles';
import { SelectAutocompleteField } from '@shared/fields/SelectAutocompleteField';
import { CREDIT_CARD_TYPE_OPTIONS, ICardFormData, IUpdateCardFormData } from '../../types';
import { updateCardValidationSchema } from '../../validation';

const initialValues: IUpdateCardFormData = {
  holderName: '',
  cardNumber: '',
  cvv: null,
  expiryDate: null,
  creditCardType: null,
};

const formConfig: IFormFieldConfig<ICardFormData>[] = [
  {
    width: '100%',
    name: 'creditCardType',
    options: CREDIT_CARD_TYPE_OPTIONS,
    component: SelectAutocompleteField,
  },
  {
    width: '100%',
    name: 'cardNumber',
    component: CreditCardInputField,
  },
  {
    width: '100%',
    name: 'cvv',
    label: 'Security code',
    component: CvvInputField,
  },
  {
    width: '100%',
    name: 'expiryDate',
    views: ['year', 'month'],
    format: 'MM/YYYY',
    minDate: new Date(),
    component: SelectDateField,
  },
  {
    width: '100%',
    name: 'holderName',
    isNotNumeric: true,
    component: TextInputField,
  },
];

interface IUpdateCardModalProps {
  handleClose  : () => void;
  handleSubmit : (values: IUpdateCardFormData) => void;
  updateCardModalPosition: number;
}

export const UpdateCardModal = ({ 
  handleClose,
  handleSubmit, 
  updateCardModalPosition,
}: IUpdateCardModalProps) => (
  <Modal 
    open
    hideBackdrop
    title="Update card form"
    dialogWidth="450px" 
    resetPosition={updateCardModalPosition}
    onClose={handleClose}
  >
    <>
      <Box height="auto">
        <Grid container>
          <Grid item md={12}>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={updateCardValidationSchema}
              onSubmit={handleSubmit}
            >
              {(props) => (
                <Form onSubmit={props.handleSubmit}>
                  <FormPart config={formConfig} />
                  <CommonButtonWrapper 
                    marginTop={4}
                  >
                    <SaveButton 
                      variant="contained" 
                      color="success" 
                      label="Update Card"
                      position="inherit"
                      width="146px"
                      isLoading={props.isSubmitting}
                    />
        
                    <Button sx={{ width: '136px' }} onClick={handleClose}>
                      Cancel
                    </Button>
                  </CommonButtonWrapper>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </Box>
    </>
  </Modal>
);
